import { useState, useCallback } from 'react';

/**
 * Hook para gerenciar estado de dialogs/modals
 * Simplifica abertura/fechamento e passagem de dados
 * 
 * @returns {Object} Estado e handlers do dialog
 * 
 * @example
 * const editDialog = useDialog();
 * 
 * // Abrir dialog com dados
 * <Button onClick={() => editDialog.handleOpen(item)}>Editar</Button>
 * 
 * // No componente Dialog
 * <Dialog open={editDialog.open} onClose={editDialog.handleClose}>
 *   {editDialog.data && <FormFields initialData={editDialog.data} />}
 * </Dialog>
 */
export const useDialog = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleOpen = useCallback((itemData = null) => {
    setData(itemData);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    // Delay para evitar flash de conteúdo durante animação de fechamento
    setTimeout(() => setData(null), 200);
  }, []);

  return {
    open,
    data,
    handleOpen,
    handleClose,
    isEdit: !!data, // Helper para saber se é edição ou criação
  };
};

export default useDialog;
